import { render } from "./ylyPackage.vue?vue&type=template&id=59d994de&scoped=true"
import script from "./ylyPackage.vue?vue&type=script&lang=js"
export * from "./ylyPackage.vue?vue&type=script&lang=js"

import "./ylyPackage.vue?vue&type=style&index=0&id=59d994de&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d994de"]])

export default __exports__